import EventBus from "@packages/event-bus";

export default {
    inject: {
        $validator: "$validator",
    },

    methods: {
        reset() {
            this.$validator.errors.clear();
            this.$validator.reset();
        },
    },

    mounted() {
        EventBus.$on("RESET_USER_MODAL", this.reset);
    },

    beforeDestroy() {
        EventBus.$off("RESET_USER_MODAL", this.reset);
    },
};
